// lazy-image/client.js
// Renders lazy-loading images.
import { isHidden, camelCase } from '../element/shared/utils/dont-need-lodash.js';

function cleanText(el, type) {
  const dataText = el.dataset[camelCase(type)] ? el.dataset[camelCase(type)].toString() : '';
  const text = dataText.replace(/"/g, '&quot;');
  return text;
};

function render(el) {
  if (isHidden(el)) {
    return;
  }

  const src = el.dataset['src'];
  if (!src) {
    return;
  }

  const imageUrl = src;
  const alt = cleanText(el, 'alt');
  const title = cleanText(el, 'title');
  const dataWidth = el.dataset['width'];
  const $newImage = document.createElement('img');
  $newImage.addEventListener('error', function handleError(el) {
    // eslint-disable-next-line no-console
    console.log(`error loading ${imageUrl}, replacing src with placeholder.`);
    $newImage.src = '/img/icons/generic-image.svg';
  }, { once: true });

  $newImage.addEventListener('load', () => {
    el.classList.add('image-loaded');
  }, { once: true });
  $newImage.setAttribute('src', imageUrl);
  $newImage.setAttribute('alt', alt);
  $newImage.setAttribute('title', title);

  // Respect image dimensions if specified
  if (dataWidth) {
    $newImage.setAttribute('style', `width: ${dataWidth}px`);
  }

  el.classList.add('rendered');

  let $prependContainer = el.querySelector('.js-image-link');
  $prependContainer = $prependContainer ? $prependContainer : el.querySelector('.js-inner-container');

  // Apply element width if specified
  const elementWidth = el.dataset[camelCase('element-width')];
  if (elementWidth) {
    el.setAttribute('style', `max-width: ${elementWidth}; width: 100%;`);
    $prependContainer.setAttribute('style', 'width: 100%;');
    $newImage.setAttribute('style', 'width: 100%;');
  }
  $prependContainer.insertBefore($newImage, $prependContainer.firstChild);
};

function observerLazyImages() {
  const els = document.querySelectorAll('.component.lazy-image');
  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const el = entry.target;
          if (!el.classList.contains('rendered')) {
            render(el);
          }
          observer.unobserve(el);
        }
      });
    }, { rootMargin: '200px 0px 200px 0px' });

    els.forEach((el) => {
      observer.observe(el);
    });
  }
}

export default function lazyImage() {
  if (document.readyState !== 'loading') {
    observerLazyImages();
  } else {
    document.addEventListener('DOMContentLoaded', observerLazyImages);
  }
}
